import { useQuery } from "@tanstack/react-query";
import { makeApiRequest } from "../components/utils";

export const useVendorAttributesList = () => {
  return useQuery({
    queryKey: ["vendorAttributesList"],
    queryFn: () =>
      makeApiRequest({
        endpoint: "/api/vendorAttributesList",
        method: "GET"
      })
  });
};
